// eslint-disable-next-line
/* eslint-disable */
import {
    Endpoint
} from "../config";
export default {
    async getLookups() {
        return await axios.get(`${Endpoint}/api/missing/getLookups`)


    }
}